<template>
  <!-- 带客服电话的袋鼠底部 -->
  <div class="daishu-footer">
    <p>{{ desc }}</p>
    <p>{{ PHONE_NUM }}</p>
  </div>
</template>
<script>
import { PHONE_NUM } from '@/config/common'
export default {
  name: 'daishu-footer',
  props: {
    desc: {
      type: String,
      default: '本服务最终解释权归袋鼠所有'
    }
  },
  data() {
    return {
      PHONE_NUM
    }
  }
}
</script>
<style lang="less" scoped>
.daishu-footer {
  text-align: center;
  margin: 48px 0;
  color: @grey;
  p {
    font-size: 26px;
    line-height: 36px;
    margin-bottom: 8px;
  }
}
</style>
